"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dig = dig;

function dig(obj, keys) {
  return keys.split('.').reduce(function (acc, key) {
    return acc[key];
  }, obj);
}